export enum ElementsPackTypes {
  TextBlocks = 'textBlocks',
  Signatures = 'signatures',
  QRCode = 'qrCode',
  Lists = 'lists',
  ImageFrames = 'imageFrames',
  ImageGrids = 'imageGrids',
  VideoEmbed = 'videoEmbed',
  Gifs = 'gifs',
  GifsReplace = 'gifsReplace',
  InteractiveList = 'interactiveList',
  MultipleChoices = 'multipleChoices',
}

export enum ElementsCategoriesTypes {
  InteractiveElements = 'interactiveElements',
  Quizzes = 'quizzes',
  Forms = 'forms',
  BasicElements = 'basicElements',
}
